import Vue from 'vue'
import VueI18n from 'vue-i18n'
import { getLanguageSetting } from '@/utils/helper.js'

// 自訂語言檔
// 報告改版工單 46：新渲染器專用文案 report.next.* 不放進 app.js——?omit 由 scripts/webpack/i18n-subtree-loader.js 在建置時去掉
// 該子樹（舊渲染器、後台等全站路徑都用不到它）；新渲染器以 ?pick 帶回來、經 mergeMessagesByFile 併入（./next-messages.js：
// zh-TW 隨 renderer-next chunk、其餘語系各自一個小 chunk 用到才載）。語言檔本身不變（結構、key 集合、check:i18n 照舊）。
// 同法另去掉兩棵：report.error.detail.*（工單 63，./error-detail-messages.js 隨進度行 chunk 帶回）、report.paramExplanations.*
// （工單 74：只有舊渲染器與舊趨勢頁用，./legacy-report-messages.js 隨 chunk legacy-report-i18n 帶回）。
import zhCN from './zh-CN.json?omit=report.next&omit=report.error.detail&omit=report.paramExplanations'
import zhTW from './zh-TW.json?omit=report.next&omit=report.error.detail&omit=report.paramExplanations'
import enUS from './en-US.json?omit=report.next&omit=report.error.detail&omit=report.paramExplanations'
import ja from './ja.json?omit=report.next&omit=report.error.detail&omit=report.paramExplanations'
import koKR from './ko-KR.json?omit=report.next&omit=report.error.detail&omit=report.paramExplanations'
import de from './de.json?omit=report.next&omit=report.error.detail&omit=report.paramExplanations'

Vue.use(VueI18n)

const messages = {
  'zh-TW': zhTW,
  'zh-CN': zhCN,
  'en-US': enUS,
  'ja': ja,
  'ja-JP': ja,
  'ko-KR': koKR,
  'de': de,
  'de-DE': de
}

// 語系代碼 → 語言檔名（同一個檔可對到多個代碼，例 ja／ja-JP）；mergeMessagesByFile 用（工單 46）
const FILE_OF = new Map([[zhTW, 'zh-TW'], [zhCN, 'zh-CN'], [enUS, 'en-US'], [ja, 'ja'], [koKR, 'ko-KR'], [de, 'de']])
const LOCALE_FILES = Object.keys(messages).map(locale => [locale, FILE_OF.get(messages[locale])])

// 取得預設語系
const locale = getLanguageSetting()

const i18n = new VueI18n({
  // 預設語言
  locale: locale,
  // 讀取不到 key 默認語言
  fallbackLocale: 'zh-TW',
  messages: messages
})

/** 語系代碼 → 語言檔名（例 ja-JP → 'ja'）；不認得的代碼回 null（vue-i18n 會退回 fallbackLocale zh-TW）。工單 46。 */
export function localeFile (locale) {
  const hit = LOCALE_FILES.find(([code]) => code === locale)
  return hit ? hit[1] : null
}

/**
 * 把「依語言檔分」的文案併進每個用該檔的語系代碼（工單 46：新渲染器專用文案隨 renderer-next chunk 載入，見 ./next-messages.js）。
 * byFile：{ 'zh-TW': {...}, 'zh-CN': {...}, 'en-US': {...}, ja: {...}, 'ko-KR': {...}, de: {...} }（鍵＝語言檔名）。重複呼叫無害。
 */
export function mergeMessagesByFile (byFile) {
  for (const [code, file] of LOCALE_FILES) {
    if (byFile && byFile[file]) i18n.mergeLocaleMessage(code, byFile[file])
  }
}

export default i18n
